import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  makeGetAllParentsByTaskIdSelector,
  makeGetSortedTaskIdsSelector,
} from "~/store/selectors/selector.taskDependencies.jsx";
import TaskDependencies from "./TaskDependencies.jsx";

const ParentTasksContainer = ({ taskId, ...rest }) => {
  const { t } = useTranslation();
  const getAllParentsByTaskId = useMemo(makeGetAllParentsByTaskIdSelector, []);
  const getSortedTaskIds = useMemo(makeGetSortedTaskIdsSelector, []);

  const parents = useSelector((state) => getAllParentsByTaskId(state, taskId));
  const tasks = useSelector((state) => getSortedTaskIds(state, parents));

  return tasks.length > 0 ? (
    <TaskDependencies
      {...rest}
      taskId={taskId}
      tasks={tasks}
      headerText={t("Predecessors")}
    />
  ) : null;
};

ParentTasksContainer.propTypes = {
  taskId: PropTypes.number,
};

export default ParentTasksContainer;
